import { useEffect, useState } from "react";
import { API_STATUS } from "../../constants";
import { GetAllPosts } from "../../apis/posts/get_all_posts";
import PostBox from "./post_box";
import PlaceHolder from "../../utils/placeholder";
import EditPostModal from "./edit_post";
import InfiniteScroll from "react-infinite-scroll-component";
import { GetSinglePost } from "../../apis/posts/get_single_post";

export default function SinglePostWrap({ postid }) {
    const [PostData, setPostData] = useState(Array.from({ length: 0 }));
    const [GetApi, setGetApi] = useState(API_STATUS);
    const [NoData, setNoData] = useState(false);
    const [edit, setEdit] = useState(false);
    const [editItem, setEditItem] = useState("");
    const [offset, setOffset] = useState(0);
    const [moredata, setHasmore] = useState(true);
    const [vmute, setVmute] = useState(true);

    useEffect(() => {
        GetSinglePost(postid, setGetApi);
    }, []);


    useEffect(() => {
        if (!GetApi.isError && !GetApi.isLoader && GetApi.data != null) {
            let res = GetApi.data;
            if (res['status'] === 1) {
                setPostData(res['data']);
                // if (res['data'].length === 0) {
                //     setNoData(true);
                //     setHasmore(false);
                // } else {
                //     setPostData((prevItems) => [...prevItems, ...res['data']]);
                // }
            } else {
                setHasmore(false);
                setNoData(true);
            }
        }
    }, [GetApi]);

    const reloadPost = () => {
        GetSinglePost(postid, setGetApi);
    }

    return <div className="flex-1 lg:max-w-[510px] md:max-w-[510px] mx-auto">
        {
            GetApi.isLoader &&
            <PlaceHolder />
        }
        {
            PostData != null && !edit &&
            <div className="xl:space-y-6 space-y-3">
                {

                    <PostBox item={PostData} setEdit={setEdit} setEditItem={setEditItem} setVmute={setVmute} vmute={vmute} />

                }
            </div>
        }
        {
            edit &&
            <EditPostModal item={editItem} setEdit={setEdit} reload={reloadPost} />
        }
        {
            NoData &&
            <div className="bg-white border border-slate-200 rounded-xl shadow-sm dark:border-slate-700 dark:bg-dark2">

                <div className="relative md:gap-8 gap-4 items-center md:p-10 p-6">

                    <div className="flex-1">

                        <p className=" mt-1 font-normal">There is no posts to show</p>
                    </div>
                </div>
            </div>
        }
    </div>
}